// extracted by mini-css-extract-plugin
module.exports = {"font_size_12":"common_font_size_12__36LRt","font_size_14":"common_font_size_14__3BVMn","font_size_13":"common_font_size_13__lbxFG","card_border":"common_card_border__5XNck"};